import React, { useState, useEffect } from 'react';
import _ from 'lodash'
import { FormattedMessage, useIntl } from 'react-intl';

import 'draft-js/dist/Draft.css';

import { Box, FormHelperText, Tooltip, Chip } from '@mui/material';

import { EMAIL_MEDIA_DATA } from './data/emailConstants';

import { CustomFormLabel, BoxBorderGrey, TextFieldCleanStyle } from '../customComponent';

import useGlobalStatus from '../../hook/useGlobalStatus';

import { HelpOutlineIcon, HighlightOffOutlinedIcon } from '../../constants/images';
import * as basicConstants from '../../constants/basic';


const EmailData = (props) => {
  const {
    media,
    emailList,
    setEmailList,
    emailString,
    setEmailString,
    EmailTemplate,
    emailTemplateCurrent,
    setEmailTemplateCurrent,
    emailTemplatePrev,
    setEmailTemplatePrev,
    emailTemplateType,
    setEmailTemplateType,
    emailRemainbudget,
    setEmailRemainbudget,
    inputErrorMsg,
    setInputErrorMsg,
    handleInput,
    optionalFields,
    requiredMetricsFields,
    selectedCampaign
  } = props;

  const { currentActiveData, setCurrentActiveData, locale, setLocale, entryPath, setEntryPath } = useGlobalStatus();
  const intl = useIntl();

  useEffect(() => {
    if (entryPath.includes('edit')) {
      setEmailList(currentActiveData.toAddresses.filter((el) => el !== 'example@gmail.com'));
      let emailType = "";

      if (media === 'LINE') {
        emailType = basicConstants.EMAIL_TEMPLATE_COVERSION_CAMPAIGN;
      } else {
        emailType = currentActiveData.mailMessageType;
      }
      setEmailTemplateType(emailType);

      if (currentActiveData.mailMessageExtra && currentActiveData.mailMessageExtra.hasOwnProperty('remainbudget')) {
        setEmailRemainbudget(currentActiveData.mailMessageExtra.remainbudget);
      }

      setEmailTemplatePrev({
        type: currentActiveData.mailMessageType,
        ...currentActiveData.mailMessageExtra
      });
      setEmailTemplateCurrent({
        type: currentActiveData.mailMessageType,
        ...currentActiveData.mailMessageExtra
      });
    }
  }, [entryPath, currentActiveData])

  const handleDeleteEmail = (email) => {
    setEmailList(prev => prev.filter(el => el !== email))
  }

  const handleEmailList = () => {
    if (!emailString) {
      setInputErrorMsg(prev => ({ ...prev, email: '' }))
      return;
    };

    const clearSpace = emailString.replace(/\s+/g, '').split(',');

    const emailCorrect = clearSpace.filter(el => {
      return basicConstants.EMAIL_REGEX.test(el);
    })

    const emailIncorrect = clearSpace.filter(el => {
      return !basicConstants.EMAIL_REGEX.test(el);
    }).join(',')

    setEmailList(prev => {
      return _.union(prev, emailCorrect);
    });

    setEmailString(emailIncorrect);

    setInputErrorMsg(prev => {
      return {
        ...prev,
        email: emailIncorrect.length ? 'emailData.recipient.errorMsg.format' : ''
      }
    })
  }

  const changeEmailTemplateType = (type) => {
    if (type === basicConstants.EMAIL_TEMPLATE_REACH) {
      setEmailTemplateCurrent({});
      setEmailTemplatePrev({});
    }

    if (type !== emailTemplateType) {
      setEmailTemplateCurrent({});
    }

    setEmailTemplateType(type);
  }

  //更改信件模板指標
  const handleChangeEmailTemplateMetric = (e, value, name, type) => {
    setEmailTemplateCurrent(prev => {
      if (type === prev.type) {
        return { ...prev, [name]: value };
      } else {
        return { ...prev, type, [name]: value };
      }
    });
  }

  const handleRemainbudget = (radio) => {
    setEmailRemainbudget(radio);

    setEmailTemplateCurrent(prev => {
      return { ...prev, remainbudget: radio }
    })
  }

  const handleSaveEmailTemplateMetric = () => {
    setEmailTemplatePrev({ ...emailTemplateCurrent });
  }

  const handleCancelEmailTemplateMetric = () => {
    if (emailTemplatePrev.type) {
      setEmailTemplateType(emailTemplatePrev.type);
    } else {
      setEmailTemplateType(basicConstants.EMAIL_TEMPLATE_REACH);
    }
    setEmailTemplateCurrent({ ...emailTemplatePrev });
  }

  // console.log('emailTemplateCurrent', emailTemplateCurrent);
  // console.log('emailTemplatePrev', emailTemplatePrev);

  return (
    <Box mb={5}>
      <Box mb={2}>
        {/* 寄送對象 */}
        <CustomFormLabel>
          <FormattedMessage id="emailData.recipient.title" />
          <Tooltip title={<FormattedMessage id={"emailData.recipient.tip"} />} placement="bottom-start">
            <HelpOutlineIcon variant="dark" />
          </Tooltip>
        </CustomFormLabel>

        <BoxBorderGrey
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}
        >
          {
            emailList.length > 0 &&
            emailList.map((el, index) => {
              return (
                el !== "" &&
                <Chip
                  key={`${el}_${index}`}
                  size="small"
                  label={el}
                  deleteIcon={<HighlightOffOutlinedIcon />}
                  onDelete={() => handleDeleteEmail(el)}
                  color="primary"
                />
              )
            })
          }

          <TextFieldCleanStyle
            error={inputErrorMsg.email || false}
            id="emailString"
            name="emailString"
            placeholder={intl.formatMessage({ id: "emailData.recipient.placeholder" })}
            value={emailString}
            onChange={handleInput}
            onBlur={handleEmailList}
          />
        </BoxBorderGrey>
        <FormHelperText error sx={{ fontSize: 14 }}>
          {inputErrorMsg?.email &&
            <FormattedMessage id={inputErrorMsg.email} />
          }
        </FormHelperText>
      </Box>

      {/* 信件範本 */}
      {
        media !== 'TABOOLA' &&
        <Box>
          <CustomFormLabel>
            <FormattedMessage id="emailData.template.title" />
            <Tooltip title={<FormattedMessage id="emailData.mail.subject" values={{ media: EMAIL_MEDIA_DATA[media].subject }} />} placement="bottom-start">
              <HelpOutlineIcon variant="dark" />
            </Tooltip>
          </CustomFormLabel>

          <EmailTemplate
            {...props}
            media={media}
            emailMediaData={EMAIL_MEDIA_DATA}
            currentData={emailTemplateCurrent}
            handleEmailTemplateType={changeEmailTemplateType}
            handleChangeEmailTemplateMetric={handleChangeEmailTemplateMetric}
            handleRemainbudget={handleRemainbudget}
            handleCancel={handleCancelEmailTemplateMetric}
            handleSubmit={handleSaveEmailTemplateMetric}
            selectedCampaign={selectedCampaign}
          />

          <FormHelperText error sx={{ fontSize: 14 }}>{inputErrorMsg.emailTemplate}</FormHelperText>

        </Box>
      }
    </Box>
  )
}

export default EmailData;